module.exports = __webpack_public_path__ + "static/csimgfm-0ecd8d6a4a3dcb9f699f9fa22bf000c1.jpg";